import { useState } from 'react';
import { useNavigate } from 'react-router';

import useStateHandler from '@/hooks/useStateHandler';
import GalleryService from '@/services/gallery.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/MarkAsSoldPopup.css';

export default function MarkAsSoldPopup({ open, close, artworkData }) {
  const { cacheHandler } = useStateHandler();
  const [formState, setFormState] = useState("");
  const [formLoading, setFormLoading] = useState(false);
  const navigate = useNavigate();

  async function submitMarkAsSold(e) {
    e.preventDefault();
    setFormLoading(true);

    const { response } = await GalleryService.markArtworkAsSold(artworkData._id, formState);

    if (response.ok) {
      cacheHandler.triggerAction("BUY_ARTWORK");
      navigate('/inventory/sold', { replace: true });
    }
  }

  return (
    <>
      <GenericPopup
        open={open}
        className="mark-as-sold-popup"
        opacity
      >
        <div className="mark-as-sold-popup__header">

          <Text className="mark-as-sold-popup__header-text" medium>
            Are you selling this artwork in-store? 
          </Text>

          <XIcon className="mark-as-sold-popup__close" onClick={close} />
        </div>

        <Text className="mark-as-sold-popup__text" paragraph justify small>
          Enter the collector's email address to enable them to claim their new
          artwork on Suarte. If they choose not to
          claim it, withdraw the piece from your inventory. For more
          info, refer to{' '}
          <a
            className="mark-as-sold-popup__a"
            href="https://help.suarte.art/sell-and-ship/"
            target="_blank"
            rel="noreferrer"
          >
            Selling In-Store
          </a>{' '}
          details.
        </Text>

        <form onSubmit={submitMarkAsSold} className="mark-as-sold-popup__form">
          <input
            type="email"
            className="mark-as-sold-popup__input font-size-medium"
            placeholder="Enter collector's email address"
            value={formState}
            onChange={e => setFormState(e.target.value)}
            spellCheck={false}
            readOnly={formLoading}
          />

          <ContinueButton
            className="font-size-medium"
            loading={formLoading}
            turnOff={!formState}
          >
            Mark as SOLD
          </ContinueButton>
        </form>
      </GenericPopup>
    </>
  );
}
